import { HttpResponse } from '@angular/common/http';

export class SymfonyListUtil {

  static getCount(res: HttpResponse<any[]>): number {
    return res && +res.headers.get('Pagination-Count') || res.body.length;
  }

}
